import { useUser } from '@/contexts/UserContext';
import { useTenantApi } from '@/hooks';
import { useState } from 'react';
import { create as createModal } from 'react-modal-promise';
import ByzzerModal2 from '@/components/modals/ByzzerModal2';
import classnames from 'classnames';
import './SupportOptionEditor.scss';
import SupportContent from '../HomePage/SupportContent';
import { useIntercom } from 'react-use-intercom';
import { useNavigate } from 'react-router-dom';
import { SUPPORT_PREF_SKIP_KEY } from '@/pages/HomePageConfigEditor/HomePageConfigEditor';
import { useLink } from '@/hooks/useLinks';
import { LINK_CODES, PAGE_CODES } from '@/constants/links.constants';

const baseClassName = 'byz-support-editor';

export function SupportOptionEditor({ onResolve, includeSkip, ...props }) {
    const { refreshUser, user } = useUser();
    const { saveUserSupportPreference } = useTenantApi();
    const [busy, setBusy] = useState(false);
    const { startTour: startTour } = useIntercom();
    const navigate = useNavigate();
    const [scheduleDemoLink] = useLink([{ linkCode: LINK_CODES.SCHEDULE_DEMO_WITH_LIVE_DATA, pageCode: PAGE_CODES.FREE_HOME }]);
    
    //TODO: the external link, intercom link and ID can be moved to UserSupportOptions and eventually that whole data can be moved to Alby
    function showProductTour(supportCode: string) {
        switch (supportCode) {
            case 'Schedule_meet':
                navigate(`/dashboard/home?product_tour_id=361317`);
                startTour(Number(361317));
                window.open(scheduleDemoLink?.linkUrl, '_blank', 'noreferrer');
                break;
            case 'take_tour':
                navigate(`/dashboard/home?product_tour_id=361317`);
                startTour(Number(361317));
                break;
            case 'help_not_needed':
                navigate(`/dashboard/home?product_tour_id=622108 `);
                startTour(Number(622108));
                break;
            default:
                break;
        }
    }

    async function handleSupportOptionSubmitClick(supportCode: string) {
        setBusy(true);
        try {
            await saveUserSupportPreference({
                supportCode: supportCode,
            });

            showProductTour(supportCode);
            refreshUser({
                metadata: {
                    ...user?.metadata,
                    supportCode: supportCode,
                },
            });
        } catch (error) {
            throw error;
        } finally {
            setBusy(false);
            onResolve(true);
        }
    }

    async function handleSkip() {
        sessionStorage.setItem(SUPPORT_PREF_SKIP_KEY, 'true')
        onResolve(false);
    }

    return (
        // @ts-ignore
        <ByzzerModal2 className={classnames(`${baseClassName}__modal`)}>
            {/* @ts-ignore */}
            <ByzzerModal2.Header closable={false}>
                <div className={classnames(`${baseClassName}__modal-headings`)}>
                    What is the best way for us to support you as you get started with Byzzer?
                </div>
            </ByzzerModal2.Header>
            {/* @ts-ignore */}
            <ByzzerModal2.Content>
                {/* @ts-ignore */}
                <ByzzerModal2.Mask show={busy} />
                <SupportContent onSubmit={handleSupportOptionSubmitClick} includeSkip={includeSkip} onSkip={handleSkip} />
            </ByzzerModal2.Content>
        </ByzzerModal2>
    );
}

// @ts-expect-error - we have issues with types in modals.  It throws a false negative 
export const openSupportOptionEditor = createModal(SupportOptionEditor);
